var text_field_default = {
  "root": "_-4MDq",
  "text": "_4KZTn",
  "input": "_4ead4",
  "small": "_9-H69",
  "medium": "OZFf2",
  "large": "OFix8",
  "webview": "wRpzP",
  "endAdornment": "W1Yd-",
  "shown": "tGwGF",
  "value": "VZeTA",
  "spinner": "PWT9A",
  "spin": "UNVs-"
};
export {
  text_field_default as default
};
//# sourceMappingURL=text-field-scss.js.map
